export const VARS = [
  "{FirstName}",
  "{LastName}",
  "{CustomerContact}",
  "{Birthday}",
  "{CountryName}",
  "{TotalOrderCount}",
  "{TotalOrderValue}",
  "{LastTransactionDate}",
  "{RegistrationDate}",
  "{MemberTier}",
  // "{BrandName}",
  // "{StoreName}",
  "{MemberPointBalance}",
  "{MemberPointBalanceExpiring}",
  "{MemberPointBalanceNextExpiryDate}",
  "{MemberBalanceVoucher}",
  "{NearestVoucherExpiryDate}",
  "{VoucherName}",
  "{VoucherExpiry}",
];

export const PROFILE_COMPLETION_REMINDER_VARS = ["{IncompleteProfileFields}"];

export const VAR_DESCRIPTIONS: Record<string, string> = {
  "{FirstName}": "Member's first name",
  "{LastName}": "Member's last name",
  "{CustomerContact}": "Member's contact number",
  "{Birthday}": "Member's date of birth",
  "{CountryName}": "Member's country",
  "{TotalOrderCount}": "Total number of orders placed",
  "{TotalOrderValue}": "Total value of orders placed",
  "{LastTransactionDate}": "Date of the member's last transaction",
  "{RegistrationDate}": "Date the member registered",
  "{MemberTier}": "Member's tier",
  "{MemberPointBalance}": "Member's current point balance",
  "{MemberPointBalanceExpiring}": "Points expiring soon",
  "{MemberPointBalanceNextExpiryDate}": "Date the expiring points run out",
  "{MemberBalanceVoucher}": "Number of vouchers available",
  "{NearestVoucherExpiryDate}": "Nearest voucher expiry date",
  "{VoucherName}": "Name of the reward voucher",
  "{VoucherExpiry}": "Voucher expiry date",
  "{VoucherValidDays}": "Days remaining before the voucher expires",
  "{EVoucherName}": "Name of the e-voucher bundle",
  "{EVoucherPrice}": "Price of the e-voucher bundle",
  "{IncompleteProfileFields}": "List of the member's incomplete profile fields",
};
